
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 11.89c.041 5.557-3.876 10.554-9.286 11.807-4.659 1.082-9.645-.794-12.442-4.674-.396-.548.454-1.159.845-.61 2.796 3.88 7.961 5.52 12.478 3.942 5.249-1.828 8.358-7.515 7.058-12.925-.996-4.157-4.439-7.437-8.633-8.215C9.377.348 4.583 2.64 2.35 6.808l1.993-.726c.631-.23.99.752.355.982L1.526 8.218a.529.529 0 01-.683-.365l-.824-3.28c-.167-.653.845-.909 1.011-.256l.47 1.87c.443-.81.985-1.572 1.606-2.257C6.518.16 12.11-1.052 16.768.97c4.31 1.869 7.195 6.22 7.232 10.92z","fill":"var(--theme-color-white-text)"}}),_c('path',{attrs:{"d":"M19.2 12c0 2.93-1.839 5.635-4.57 6.708-2.761 1.089-5.997.331-7.995-1.857C3.293 13.184 4.71 7.113 9.328 5.292 13.993 3.456 19.2 7.002 19.2 12zm-4.88 1.778c.605.305 1.086-.631.479-.942l-1.907-.962a.918.918 0 00-.385-.632V7.95c0-.679-1.054-.679-1.054 0v3.293c-.923.642-.027 2.1.964 1.568l1.903.968z","fill":"var(--theme-color-white-text)"}})])
          )
        }
      }
    